import * as React from 'react';
import { BreadCrumb } from '@helpcenter/bread-crumb-dumb';
import type { InjectedProps as PathParamProps } from '@helpcenter/with-path-params';
import type { WrappedComponentProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import { di } from 'react-magnetic-di';
import Breadcrumbs from '@atlaskit/breadcrumbs/breadcrumbs';
import { isCSMHelpCenter } from '@atlassian/help-center-common-util/advanced-help-center';
import { getEnv } from '@atlassian/help-center-common-util/env';
import { getHelpCenterUrl } from '@atlassian/help-center-common-util/url';
import messages from './messages';

export interface SelectProps {
	sharedPortalName: string;
	portalName?: string | undefined;
	categoryName?: string | undefined;
	articleTitle?: string | undefined;
	requestKey?: string | undefined;
	requestUrl?: string | undefined;
	showRequests?: boolean;
}

export interface AdditionalBreadCrumbsProps {
	additionalBreadCrumbs?: React.ReactElement[];
}

export type ExternalProps = PathParamProps;

export const BreadCrumbsDumb: React.FunctionComponent<
	SelectProps & ExternalProps & AdditionalBreadCrumbsProps & WrappedComponentProps
> = ({
	sharedPortalName,
	portalName,
	categoryName,
	articleTitle,
	portalId,
	categoryId,
	articleId,
	showRequests,
	intl,
	requestKey,
	requestUrl,
	additionalBreadCrumbs,
}) => {
	di(isCSMHelpCenter);

	const requestCreateBreadcrumb = showRequests
		? intl.formatMessage(messages.raiseRequestBreadcrumb)
		: undefined;

	const isCSM = isCSMHelpCenter(getEnv().helpCenterType);

	return (
		<Breadcrumbs label={intl.formatMessage(messages.breadcrumbsLabel)}>
			<BreadCrumb
				to={getHelpCenterUrl()}
				name={!isCSM ? sharedPortalName : intl.formatMessage(messages.breadcrumbsHome)}
				isFirstCrumb
				actionSubjectId="helpCenterBreadcrumb"
			>
				{!isCSM &&
					portalId !== undefined && (
						// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
						<BreadCrumb
							to={`/portal/${portalId}`}
							name={portalName}
							actionSubjectId="portalBreadcrumb"
						>
							<BreadCrumb
								to={requestUrl || ''}
								name={requestKey}
								actionSubjectId="requestBreadcrumb"
								testId="requestKey"
							/>
							<BreadCrumb
								// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
								to={`/portal/${portalId}/group/-1`}
								name={requestCreateBreadcrumb}
								actionSubjectId="requestCreateBreadcrumb"
							/>
							<BreadCrumb
								// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
								// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
								to={`/portal/${portalId}/topic/${categoryId}`}
								name={categoryName}
								actionSubjectId="categoryBreadcrumb"
							>
								<BreadCrumb
									// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
									// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
									to={`/portal/${portalId}/topic/${categoryId}/article/${articleId}`}
									name={articleTitle}
									actionSubjectId="articleBreadcrumb"
								/>
							</BreadCrumb>
							<BreadCrumb
								// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
								// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
								to={`/portal/${portalId}/article/${articleId}`}
								name={articleTitle}
								actionSubjectId="articleBreadcrumb"
							/>
						</BreadCrumb>
					)}
				{/*TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.*/}
				<BreadCrumb
					// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
					to={`/article/${articleId}`}
					name={articleTitle}
					actionSubjectId="articleBreadcrumb"
				/>
				{additionalBreadCrumbs?.map((breadCrumb) => breadCrumb)}
			</BreadCrumb>
		</Breadcrumbs>
	);
};

export default injectIntl(BreadCrumbsDumb);
